export default __webpack_public_path__ + "static/planning-development-hero-1a5eb1a46b409a8f1a6dcfeaad608b4c.webp";